module.exports = __webpack_public_path__ + "static/media/D518GriffinStNW_2018-06-05_8.79b43f61.jpg";